const UNKNOWN_VALUE = 'Unknown';

export const translateCityName = (name: string, t: (key: string) => string) =>
  UNKNOWN_VALUE.localeCompare(name) === 0 ? t('qr.filters.all.unknown') : name;
